import { render, staticRenderFns } from "./sbsp-filter-box.vue?vue&type=template&id=31f4f90b&scoped=true&"
import script from "./sbsp-filter-box.vue?vue&type=script&lang=js&"
export * from "./sbsp-filter-box.vue?vue&type=script&lang=js&"
import style0 from "./sbsp-filter-box.vue?vue&type=style&index=0&id=31f4f90b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f4f90b",
  null
  
)

export default component.exports